module.exports = __webpack_public_path__ + "img/stick_activites_vtt_descente.c5c1f39c.svg";